import React, { useMemo } from 'react';

import { useSelector, shallowEqual } from 'react-redux';
import { user } from '../../../redux/user';
import Tooltip from '../../../components/Tooltip/Tooltip';
import editIcon from '../../../assets/images/purple-edit-pencil.svg';

import './UnitDetails.scss';

const UnitDetails = React.memo(
	({ unitId, handleEdit, allowEdit, hasSegments }) => {
		const userData = useSelector(user, shallowEqual);

		const unitName = useMemo(() => {
			// eslint-disable-next-line camelcase
			return userData.activeFacility.units.find((u) => u.id === unitId)?.unit_name;
		}, [unitId, userData.activeFacility.units]);

		return (
			<div
				className="unit-details"
				aria-hidden
				onClick={() => {
					if (allowEdit && handleEdit) {
						handleEdit();
					}
				}}
			>
				{hasSegments ? (
					<>
						Unit:<span className="segments-title"> See Split details</span>
					</>
				) : (
					(unitName || (!unitName && allowEdit)) && (
						<Tooltip label="Unit Assignment" placement="bottom">
							Unit: <span className="bold"> {unitName || ' - '}</span>
							{allowEdit && <img className="pencil-icon" alt="edit-icon" src={editIcon} />}
						</Tooltip>
					)
				)}
			</div>
		);
	},
	(prevProps, nextProps) => {
		// Memoize based on the unitId and hasSegments prop
		return (
			prevProps.unitId === nextProps.unitId &&
			prevProps.allowEdit === nextProps.allowEdit &&
			prevProps.hasSegments === nextProps.hasSegments
		);
	}
);

export default UnitDetails;
